import {
    Tooltip,
    TooltipContent,
    TooltipTrigger,
} from "../ui/tooltip";
import { ChevronUp, ChevronDown } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

type SubNavItem = { name: string; href: string };

interface NavItemWithChildrenProps {
    name: string;
    icon: React.ReactNode;
    children: SubNavItem[];
    expanded: boolean;
    isOpen: boolean;
    isAnyChildActive: boolean;
    hoverBg: string;
    onToggle: () => void;
}

export const NavItemWithChildren = ({
    name,
    icon,
    children,
    expanded,
    isOpen,
    isAnyChildActive,
    hoverBg,
    onToggle,
}: NavItemWithChildrenProps) => {
    const location = useLocation();

    return (
        <div>
            <Tooltip>
                <TooltipTrigger asChild>
                    <button
                        type="button"
                        onClick={onToggle}
                        className={`flex items-center justify-between gap-3 w-full px-6 py-3 transition-colors ${isAnyChildActive ? "bg-white/5" : hoverBg}`}
                    >
                        <div className="flex items-center gap-3">
                            <span>{icon}</span>
                            {expanded && <span>{name}</span>}
                        </div>
                        {expanded && (isOpen ? <ChevronUp size={18} /> : <ChevronDown size={18} />)}
                    </button>
                </TooltipTrigger>
                {!expanded && (
                    <TooltipContent side="right">{name}</TooltipContent>
                )}
            </Tooltip>

            {expanded && isOpen && (
                <div className="ml-6 border-l border-white/10 w-48">
                    {children.map((child) => {
                        const childActive = location.pathname === child.href;
                        return (
                            <Link
                                key={child.name}
                                to={child.href}
                                className={`flex items-center gap-3 w-full px-6 py-2 ml-2 my-1 transition-colors rounded-lg ${childActive ? "bg-orange-500 text-white" : hoverBg}`}
                            >
                                {expanded && <span>{child.name}</span>}
                            </Link>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

